import httpClient from '@/api/httpClient'

export class IntervalReportApi {
  static async search(keyword, advertiserId, pageNo, pageSize) {
    const res = await httpClient.post('/interval_report/search', {
      query: {
        advertiserId,
        keyword,
      },
      pageNo: pageNo,
      pageSize: pageSize,
    })
    return res.data
  }

  static async create(request) {
    const res = await httpClient.post('/interval_report', request)
    return res.data
  }

  static async update(request) {
    const res = await httpClient.put(`/interval_report/${request.id}`, request)
    return res.data
  }

  static async get(id) {
    const res = await httpClient.get(`/interval_report/${id}`)
    return res.data
  }

  static async updateStatus(id, status) {
    const res = await httpClient.put(`/interval_report/${id}/status`, {
      status,
    })
    return res.data
  }

  static async remove(id) {
    await httpClient.delete(`/interval_report/${id}`)
  }

  static async getReport(request) {
    const url = `/ad_report/${request.advertiserId}/download_report`
    const res = await httpClient.post(url, {
      query: {
        insertionOrderIds: request.insertionOrderIds,
        dimension: request.dimension,
        interval: request.interval,
        period: request.period,
        isIncludeBudget: request.isIncludeBudget,
        isIncludeCreative: request.isIncludeCreative,
      },
      format: request.format,
    })
    return res.data
  }
}
